import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user_service';
import { User } from '../types/user';

@Injectable({
  providedIn: 'root'
})
export class UserProfileAtGuard {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    const userName = route.paramMap.get('username');

    if (userName) {
      return this.userService.getUserProfileByUsername(userName).then((u: User) => {
        return u && u.id ? true : false;
      })
      .catch(() => {
        this.router.navigate(['/']);
        return false; 
      });
    } else {
      return Promise.resolve(false); 
    }
  }
}